export default __webpack_public_path__ + "static/media/profileCam.1f8eb5a5.svg";